import type { MessageEventData, UserSendTemplateMessageEvent } from '../types/interfaces'
import { MessageSourceType } from '../types/enums'
import type { useMessageStore } from '../stores/useMessageStore'
import type { useChatStore } from '../stores/useChatStore'
import { isQueuedChat } from '../stores/useChatStore'
import type { useNotifications } from '@/composables/useNotifications'
import { toChatIdentity } from './contactIdentity'

export const createMessageEventHandlers = (
  messageStore: ReturnType<typeof useMessageStore>,
  chatStore: ReturnType<typeof useChatStore>,
  notifications: ReturnType<typeof useNotifications>,
) => {
  const handleMessageEvent = (data: MessageEventData) => {
    // Un mismo mensaje puede llegar repetido (reintento de webhook del proveedor):
    // el chat se actualiza igual, pero no se vuelve a notificar.
    const isNewMessage = messageStore.handleMessageEvent(data)

    if (data.chat) {
      const chat = chatStore.chats.find((c) => c.chat_id === data.chat_id)
      if (chat) {
        // Un cliente que llegó solo con BSUID puede traer ahora su teléfono
        // (compartió su contacto) o un username distinto: se toma lo que venga.
        const identity = toChatIdentity(data.chat)

        if (data.chat.name && chat.contact_name !== identity.contact_name) {
          chat.contact_name = identity.contact_name
        }

        if (identity.contact_phone && chat.contact_phone !== identity.contact_phone) {
          chat.contact_phone = identity.contact_phone
        }

        if (identity.contact_username && chat.contact_username !== identity.contact_username) {
          chat.contact_username = identity.contact_username
        }

        if (data.chat.status && chat.status !== data.chat.status) {
          chat.status = data.chat.status
        }

        if (data.chat.campaign_id && chat.campaign_id !== data.chat.campaign_id) {
          chat.campaign_id = data.chat.campaign_id
        }
      }
    }

    if (isNewMessage && data.content.source_type === MessageSourceType.ENTRANTE) {
      const chat = chatStore.chats.find((c) => c.chat_id === data.chat_id)
      if (chat) {
        notifications.notifyNewMessage({
          contactName: chat.contact_name || data.chat?.name || '',
          messagePreview:
            data.content.content?.content ||
            data.content.content?.text ||
            'Archivo',
          chatId: data.chat_id,
          isCurrentChat: chatStore.selectedChatId === data.chat_id,
          // Un chat de la cola no es de nadie: su aviso lo gobierna la campana.
          isQueued: isQueuedChat(chat),
        })
      }
    }
  }

  const handleUserSendTemplateMessage = (data: UserSendTemplateMessageEvent) => {

    messageStore.handleUserSendTemplateMessage(data)
  }

  return {
    handleMessageEvent,
    handleUserSendTemplateMessage,
  }
}

